import { Controller } from "@hotwired/stimulus"
import StimulusReflex from 'stimulus_reflex';
export default class extends Controller {
  
  connect() {
       StimulusReflex.register(this);
       /*
       this.autoRefreshPage = setInterval(() => {
         this.stimulate();
         console.log("refrshing dashboard");
       }, 30000)

       */
  }
  
  disconnect() {
	  clearInterval(this.autoRefreshPage);
  }
    
}

